/* TRENDY LIVE (09-10-2026). Sin dependencias.
   Parche 12.7: selector de variante, aviso del carrito con lo que falta para el envío gratis (de /cart.js),
   pósters perezosos, teclado/foco accesibles, sonido en iOS, URL con la pestaña. Nada descarga el video. */
(function () {
  var root = document.getElementById('tlv');
  if (!root || root.dataset.listo) return;
  root.dataset.listo = '1';
  var feed = root.querySelector('[data-tlv-feed]');
  var slides = [].slice.call(root.querySelectorAll('[data-tlv-s]'));
  if (!slides.length) return;
  var bg = root.querySelector('[data-tlv-bg]');
  var toastEl = root.querySelector('[data-tlv-toast]');
  var sheet = root.querySelector('[data-tlv-sheet]');
  var muted = true, actual = null, tToast = 0;
  var DESK = window.matchMedia ? matchMedia('(min-width:900px)') : { matches: false };
  /* (09-10-2026) conexión lenta = Ahorro de datos o 2g: no se precarga el video siguiente (se baja al llegar).
     3g NO cuenta: en Uruguay el 4G flojo a veces se reporta como 3g. Sin la API (iOS, Firefox) = no lenta. */
  var c0 = navigator.connection, LENTA = !!(c0 && (c0.saveData || /2g/.test(c0.effectiveType || '')));
  var turno = 0; /* cada activar() suma uno: una precarga vieja no corre si ya se cambió de video */
  var ENVIO = 300000; /* envío gratis desde $3.000 (en centavos, como /cart.js) */
  var LS = 'tlv-likes';
  var store = function (k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } };
  var likes = store(LS) || [];
  var pend = store('tlv-pend') || {};
  var plata = function (c) { return '$' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var visibles = function () { return slides.filter(function (s) { return !s.hidden; }); };

  function cerrarToast() { toastEl.hidden = true; root.classList.remove('has-toast'); }
  function toast(html, ms, cls) {
    toastEl.innerHTML = html; toastEl.className = 'tlv__toast' + (cls ? ' ' + cls : '');
    toastEl.hidden = false; root.classList.add('has-toast');
    clearTimeout(tToast); tToast = setTimeout(cerrarToast, ms || 2600);
  }
  toastEl.addEventListener('click', function (e) { if (e.target.closest('[data-tlv-tx]')) { clearTimeout(tToast); cerrarToast(); } });

  function vid(s) { return s.querySelector('video'); }
  function poner(s) { var v = vid(s); if (v && v.dataset.poster && !v.getAttribute('poster')) v.poster = v.dataset.poster; }
  function cargar(s) {
    var v = vid(s); if (!v) return; poner(s);
    if (v.dataset.ok) return;
    v.src = v.dataset.src; v.dataset.ok = '1'; v.load();
  }
  function soltar(s) {
    var v = vid(s); if (!v || !v.dataset.ok) return;
    v.pause(); v.removeAttribute('src'); v.load(); delete v.dataset.ok;
  }
  function fondo(s) {
    if (!bg || !DESK.matches || !s) return;
    var u = 'url("' + s.dataset.poster + '")';
    if (bg.style.backgroundImage === u) return;
    if (!bg.style.backgroundImage) { bg.style.backgroundImage = u; return; }
    bg.style.opacity = 0; clearTimeout(bg._t);
    bg._t = setTimeout(function () { bg.style.backgroundImage = u; bg.style.opacity = ''; }, 160);
  }
  function play(s, v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {
      /* iOS: con sonido fuera de un toque lo rechaza → sigue mudo y se avisa (sin cambiar la preferencia) */
      if (!v.muted) { v.muted = true; v.play().then(function () { if (actual === s) toast('Tocá el video para el sonido 🔊', 2000); }, function () { s.classList.add('is-paused'); }); }
      else s.classList.add('is-paused');
    });
  }
  function activar(s) {
    if (actual === s) return;
    if (actual) { var va = vid(actual); if (va) va.pause(); }
    actual = s; var yo = ++turno;
    if (sheet && !sheet.hidden) { sheet.hidden = true; root.classList.remove('com-open'); }
    if (toastEl.classList.contains('is-cart')) cerrarToast();
    /* (09-10-2026) primero el video que se mira: se carga solo el actual; ±1 y ±2 llevan póster
       y los ±1 se precargan recién cuando el actual ya suena (abajo). Se suelta el resto (visibles de la pestaña). */
    var vis = visibles(), i = vis.indexOf(s), vecinos = [];
    vis.forEach(function (x, k) { var d = Math.abs(k - i); if (d === 0) cargar(x); else if (d === 1) { poner(x); vecinos.push(x); } else if (d === 2) poner(x); else soltar(x); });
    slides.forEach(function (x) { if (x.hidden) soltar(x); });
    var v = vid(s);
    if (v) { v.muted = muted; v.currentTime = 0; s.classList.remove('is-paused'); play(s, v); }
    /* precarga de ±1 cuando el actual arranca ('playing'); nunca con conexión lenta. A los 4 s, solo si el actual
       quedó pausado o con error (autoplay bloqueado): si todavía está bajando para arrancar, se sigue esperando
       ('playing'), para no repartir la conexión (medido: a 1,6 Mbps el primero tarda más de 4 s en arrancar).
       Si se desliza antes, activar() carga el nuevo actual en el momento. */
    if (!LENTA && vecinos.length) {
      var hecho = false;
      var pre = function () { if (hecho || turno !== yo || actual !== s) return; hecho = true; vecinos.forEach(cargar); };
      if (v && v.readyState >= 3 && !v.paused) pre();
      else { if (v) v.addEventListener('playing', pre, { once: true }); setTimeout(function () { if (!v || v.paused || v.error) pre(); }, 4000); }
    }
    if (typeof pintarNav === 'function') setTimeout(pintarNav, 0);
    var inf = s.querySelector('.tlv__info'); if (inf) s.style.setProperty('--tlv-ih', inf.offsetHeight + 'px');
    fondo(s);
    try { var u = new URL(location.href); u.searchParams.set('v', s.dataset.key); history.replaceState({}, '', u); } catch (e) {}
  }

  /* qué video está en pantalla */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > .6) activar(e.target); });
  }, { root: feed, threshold: [.6] });
  slides.forEach(function (s) { io.observe(s); });

  /* progreso (en compu se puede tocar para adelantar) */
  slides.forEach(function (s) {
    var v = vid(s), bar = s.querySelector('[data-tlv-prog]'), pr = s.querySelector('.tlv__prog');
    v.addEventListener('timeupdate', function () { if (v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')'; });
    if (pr) pr.addEventListener('click', function (e) {
      if (!DESK.matches) return;
      e.stopPropagation();
      var r = pr.getBoundingClientRect();
      if (v.duration) v.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * v.duration;
    });
  });

  /* sonido */
  var mb = root.querySelector('[data-tlv-mute]'), snd = root.querySelector('[data-tlv-snd]');
  function setMute(m) {
    muted = m;
    slides.forEach(function (s) { vid(s).muted = m; });
    mb.querySelector('[data-off]').hidden = !m; mb.querySelector('[data-on]').hidden = m;
    mb.setAttribute('aria-label', m ? 'Activar sonido' : 'Silenciar');
    root.classList.toggle('is-muted', m);
    if (!m) { root.classList.add('snd-off'); store('tlv-snd', 1); }
  }
  mb.addEventListener('click', function () {
    setMute(!muted);
    if (actual && !muted) { vid(actual).play().catch(function () {}); actual.classList.remove('is-paused'); }
  });
  if (snd) {
    snd.addEventListener('click', function () { if (muted) mb.click(); });
    /* celular: la pastilla se muestra solo en la primera visita y 6 s; en compu queda mientras esté mudo */
    if (store('tlv-snd')) root.classList.add('snd-off');
    else setTimeout(function () { root.classList.add('snd-off'); }, 6000);
  }

  /* me gusta + guardados */
  function pintarLikes() {
    slides.forEach(function (s) {
      var on = likes.indexOf(s.dataset.key) > -1, b = s.querySelector('[data-tlv-like]');
      b.setAttribute('aria-pressed', String(on));
      b.querySelector('[data-tlv-liketxt]').textContent = on ? 'Guardado' : 'Me gusta';
    });
    root.querySelector('[data-tlv-nsav]').textContent = likes.length || '';
  }
  function like(s, forzar) {
    var k = s.dataset.key, i = likes.indexOf(k);
    if (i > -1 && !forzar) likes.splice(i, 1);
    else if (i < 0) { likes.push(k); toast('♥ Guardado en <b>Guardados</b>'); }
    store(LS, likes); pintarLikes();
  }
  pintarLikes();

  /* tocar el video: un toque pausa, dos toques = me gusta */
  slides.forEach(function (s) {
    var media = s.querySelector('.tlv__media'), t0 = 0, tm = 0;
    media.addEventListener('click', function () {
      var now = Date.now();
      if (now - t0 < 280) {
        clearTimeout(tm); t0 = 0;
        s.classList.remove('is-burst'); void s.offsetWidth; s.classList.add('is-burst');
        like(s, true); return;
      }
      t0 = now;
      tm = setTimeout(function () {
        var v = vid(s);
        if (v.muted && !muted) { v.muted = false; v.play().catch(function () {}); s.classList.remove('is-paused'); return; }
        if (muted) { setMute(false); v.play().catch(function () {}); s.classList.remove('is-paused'); return; }
        if (v.paused) { v.play().catch(function () {}); s.classList.remove('is-paused'); } else { v.pause(); s.classList.add('is-paused'); }
      }, 290);
    });
    s.querySelector('[data-tlv-like]').addEventListener('click', function () { like(s); });
  });

  /* pista de deslizar: se va con el primer toque, scroll o tecla */
  var hint = root.querySelector('[data-tlv-hint]');
  function sinPista() { if (hint) hint.hidden = true; }

  /* pestañas */
  var vacio = root.querySelector('[data-tlv-vacio]');
  var orig = slides.slice(), vioRk = false;
  function tab(cual, quiero) {
    sinPista();
    root.querySelectorAll('.tlv__tabs [data-tlv-tab]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.tlvTab === cual); });
    /* Ranking: los que tienen puesto, en orden de ventas; el resto vuelve a su orden original */
    var rk = orig.filter(function (s) { return s.dataset.puesto; }).sort(function (a, b) { return a.dataset.puesto - b.dataset.puesto; });
    var orden = cual === 'ranking' ? rk.concat(orig.filter(function (s) { return rk.indexOf(s) < 0; })) : orig;
    orden.forEach(function (s) { feed.insertBefore(s, vacio); });
    slides = orden;
    var hay = 0;
    slides.forEach(function (s) {
      var ver = cual === 'todo' || (cual === 'ranking' ? !!s.dataset.puesto : likes.indexOf(s.dataset.key) > -1);
      s.hidden = !ver; if (ver) hay++;
    });
    vacio.hidden = !(cual === 'guardados' && !hay);
    root.classList.toggle('is-vacio', !vacio.hidden);
    /* el video de antes no puede seguir sonando oculto */
    if (actual) { var va = vid(actual); if (va) va.pause(); actual.classList.remove('is-paused'); }
    actual = null;
    var vis = visibles(), prim = quiero && vis.indexOf(quiero) > -1 ? quiero : vis[0];
    if (prim && prim !== vis[0]) prim.scrollIntoView(); else feed.scrollTo({ top: 0 });
    if (prim) setTimeout(function () { activar(prim); }, 60);
    else if (typeof pintarNav === 'function') pintarNav();
    try { var u = new URL(location.href); if (cual === 'todo') u.searchParams.delete('tab'); else u.searchParams.set('tab', cual); if (!prim) u.searchParams.delete('v'); history.replaceState({}, '', u); } catch (e) {}
    if (cual === 'ranking' && !vioRk && rk.length) {
      vioRk = true;
      var n = rk.filter(function (s) { return !s.hidden; }).length;
      setTimeout(function () { toast('🔥 Lo más vendido de Trendy', 3200); }, 400);
    }
  }
  root.addEventListener('click', function (e) { var b = e.target.closest('[data-tlv-tab]'); if (b) tab(b.dataset.tlvTab); });

  /* compartir (solo el link a la página, nunca el archivo del video) */
  function link(s) { return location.origin + '/pages/live?v=' + encodeURIComponent(s.dataset.key); }
  slides.forEach(function (s) {
    s.querySelector('[data-tlv-share]').addEventListener('click', function () {
      var u = link(s), t = s.dataset.name + (s.dataset.price ? ' a ' + s.dataset.price : '') + ' en Trendy 👀';
      var wa = 'https://wa.me/?text=' + encodeURIComponent(t + ' ' + u);
      if (navigator.share && !DESK.matches) { navigator.share({ title: t, text: t, url: u }).catch(function () {}); return; }
      var avisar = function () { toast('Link copiado ✓ <a href="' + wa + '" target="_blank" rel="noopener">Mandalo por WhatsApp</a>', 3500); };
      if (navigator.clipboard) navigator.clipboard.writeText(u).then(avisar, function () { window.open(wa, '_blank', 'noopener'); });
      else window.open(wa, '_blank', 'noopener');
    });
  });

  /* selector de variante (arriba de los botones): cambia lo que se agrega, el precio y el combo */
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-tlv-var]'); if (!c) return;
    var s = c.closest('[data-tlv-s]'); if (!s) return;
    s.querySelectorAll('[data-tlv-var]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === c)); });
    var id = c.dataset.tlvVar, add = s.querySelector('.tlv__add');
    if (add) add.dataset.tlvAdd = id;
    var em = s.querySelector('[data-tlv-em]'); if (em) em.innerHTML = c.dataset.em;
    s.dataset.price = c.dataset.price;
    var cb = s.querySelector('.tlv__combo');
    if (cb) {
      var ids = cb.dataset.tlvAdd.split(','); ids[0] = id; cb.dataset.tlvAdd = ids.join(',');
      var t = cb.querySelector('[data-tlv-tot]'); if (t) t.textContent = c.dataset.tot;
      var en = cb.querySelector('[data-tlv-envio]'); if (en) en.textContent = c.dataset.free ? ' · envío gratis' : ' · un solo envío';
      if (c.dataset.free) cb.dataset.free = '1'; else delete cb.dataset.free;
    }
    medirInfo();
  });

  /* carrito */
  var cartBtn = root.querySelector('.tlv__cart'), cnt = root.querySelector('[data-tlv-count]');
  function contar() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      cnt.textContent = c.item_count; cnt.hidden = !c.item_count;
      /* compu: barra de envío gratis con el total real del carrito */
      var falta = ENVIO - c.total_price;
      root.querySelectorAll('[data-tlv-free]').forEach(function (p) {
        p.hidden = !c.item_count;
        p.innerHTML = falta > 0 ? 'Te faltan <b>' + plata(falta) + '</b> para el envío gratis' : '🎁 Ya tenés <b>envío gratis</b>';
        p.style.setProperty('--f', Math.min(1, c.total_price / ENVIO));
      });
      return c;
    }).catch(function () { return null; });
  }
  contar();
  function volar(src, desde) {
    if (!src) return;
    var r = desde.getBoundingClientRect(), d = cartBtn.getBoundingClientRect();
    var im = document.createElement('img'); im.src = src; im.className = 'tlv__fly'; im.alt = '';
    im.style.left = (r.left + r.width / 2 - 27) + 'px'; im.style.top = (r.top - 10) + 'px';
    document.body.appendChild(im);
    requestAnimationFrame(function () {
      im.style.transform = 'translate(' + (d.left - r.left - r.width / 2 + 34) + 'px,' + (d.top - r.top + 4) + 'px) scale(.25)'; im.style.opacity = '.4';
    });
    setTimeout(function () { im.remove(); cartBtn.classList.remove('is-pop'); void cartBtn.offsetWidth; cartBtn.classList.add('is-pop'); }, 720);
  }
  function avisoCarrito(c, combo) {
    var h = '<div class="tlv__th"><b>' + (combo ? '¡Combo agregado!' : '¡Agregado!') + '</b>' + (c ? '<span>Total ' + plata(c.total_price) + '</span>' : '') +
      '<button type="button" class="tlv__tx" data-tlv-tx aria-label="Cerrar aviso">×</button></div>';
    if (c) {
      var falta = ENVIO - c.total_price;
      h += '<p>' + (falta > 0 ? 'Te faltan <b>' + plata(falta) + '</b> para el envío gratis' : '¡Tenés envío gratis! 🚚') + '</p>' +
        '<i class="tlv__tbar" style="--f:' + Math.min(1, c.total_price / ENVIO) + '"></i>';
    }
    h += '<div class="tlv__tacts"><a href="/checkout" class="tlv__go">Finalizar compra</a><a href="/cart">Ver carrito</a></div>';
    toast(h, 7000, 'is-cart');
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tlv-add]'); if (!b || b.disabled) return;
    b.disabled = true;
    var items = b.dataset.tlvAdd.split(',').map(function (id) { return { id: Number(id), quantity: 1 }; });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) {
        if (!r.ok) return r.json().catch(function () { return {}; }).then(function (j) { j = j || {}; j.status = r.status; throw j; });
        return r.json();
      })
      .then(function () {
        volar(b.dataset.img, b); b.classList.add('is-ok');
        contar().then(function (c) { avisoCarrito(c, items.length > 1); });
        setTimeout(function () { b.disabled = false; b.classList.remove('is-ok'); }, 2200);
      })
      .catch(function (j) { b.disabled = false; toast(j && j.status === 422 ? 'No hay stock suficiente de ese producto 😕' : 'No se pudo agregar. Probá de nuevo.'); });
  });

  /* comentarios */
  var list = root.querySelector('[data-tlv-list]'), nocom = root.querySelector('[data-tlv-nocom]');
  var form = root.querySelector('[data-tlv-form]'), sheetS = null, opener = null;
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function cerrarCom() {
    sheet.hidden = true; root.classList.remove('com-open');
    var o = opener && opener !== document.body ? opener : sheetS && sheetS.querySelector('[data-tlv-com]');
    if (o && o.focus) o.focus({ preventScroll: true });
  }
  function abrirCom(s) {
    sheetS = s; opener = document.activeElement;
    var art = s.querySelector('[data-tlv-art]').innerHTML.trim(), k = s.dataset.key;
    list.innerHTML = s.querySelector('[data-tlv-coms]').innerHTML;
    /* pendientes propios: se borran si ya se aprobaron (aparecen en la lista) o tienen más de 14 días */
    var txt = list.textContent;
    pend[k] = (pend[k] || []).filter(function (c) { return c.t && Date.now() - c.t < 14 * 864e5 && txt.indexOf(c.b) < 0; });
    store('tlv-pend', pend);
    pend[k].forEach(function (c) { list.insertAdjacentHTML('afterbegin', '<li class="is-pend"><b>' + esc(c.a) + '</b><time>recién</time><p>' + esc(c.b) + '</p></li>'); });
    nocom.hidden = !!list.children.length; list.hidden = !nocom.hidden;
    root.querySelector('[data-tlv-sh-t]').textContent = 'Comentarios · ' + s.dataset.name;
    form.action = art + '/comments';
    form.hidden = !art;
    sheet.hidden = false; root.classList.add('com-open');
    try { var n = store('tlv-yo'); if (n) { form.elements['comment[author]'].value = n.a || ''; form.elements['comment[email]'].value = n.e || ''; } } catch (e) {}
    /* compu: al campo; celular: a Cerrar (no abre el teclado) */
    setTimeout(function () {
      var f = (!DESK.matches || form.hidden) ? sheet.querySelector('[data-tlv-close]') : form.elements[form.elements['comment[author]'].value ? 'comment[body]' : 'comment[author]'];
      if (f) f.focus({ preventScroll: true });
    }, 60);
  }
  slides.forEach(function (s) { s.querySelector('[data-tlv-com]').addEventListener('click', function () { abrirCom(s); }); });
  sheet.addEventListener('click', function (e) { if (e.target === sheet || e.target.closest('[data-tlv-close]')) cerrarCom(); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var fd = new FormData(form), a = fd.get('comment[author]'), b = fd.get('comment[body]');
    store('tlv-yo', { a: a, e: fd.get('comment[email]') });
    var btn = form.querySelector('button'); btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new URLSearchParams(fd), redirect: 'follow' }).then(function (r) {
      if (/challenge/.test(r.url)) { form.submit(); return; }   /* Shopify pidió captcha: se manda el formulario normal */
      if (!r.ok) throw r;
      var k = sheetS.dataset.key; (pend[k] = pend[k] || []).push({ a: a, b: b, t: Date.now() }); store('tlv-pend', pend);
      list.insertAdjacentHTML('afterbegin', '<li class="is-pend"><b>' + esc(a) + '</b><time>recién</time><p>' + esc(b) + '</p></li>');
      nocom.hidden = true; list.hidden = false; form.elements['comment[body]'].value = '';
      toast('¡Gracias! Lo publicamos cuando lo revisemos ✓', 3200);
    }).catch(function () { toast('No se pudo enviar. Revisá nombre, email y comentario.', 3200); }).then(function () { btn.disabled = false; });
  });
  function cicloTab(e) {
    var f = [].filter.call(sheet.querySelectorAll('button,input:not([type=hidden])'), function (x) { return x.offsetParent && !x.disabled; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (f.indexOf(document.activeElement) < 0) { e.preventDefault(); a.focus(); }
    else if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  /* celular: las acciones van justo arriba del bloque de info (mide su alto real) */
  function medirInfo() {
    slides.forEach(function (s) { var i = s.querySelector('.tlv__info'); if (i) s.style.setProperty('--tlv-ih', i.offsetHeight + 'px'); });
  }
  medirInfo();
  window.addEventListener('resize', function () { medirInfo(); fondo(actual); });

  /* flechas (escritorio) + posición real dentro de la pestaña */
  var navs = root.querySelectorAll('[data-tlv-nav]'), posEl = root.querySelector('[data-tlv-pos]');
  function pintarNav() {
    var vis = visibles(), i = vis.indexOf(actual);
    if (navs[0]) navs[0].disabled = i <= 0;
    if (navs[1]) navs[1].disabled = i < 0 || i >= vis.length - 1;
    if (posEl) posEl.textContent = i < 0 ? '' : (i + 1) + ' / ' + vis.length;
  }
  navs.forEach(function (b) {
    b.addEventListener('click', function () {
      var vis = visibles(), i = vis.indexOf(actual), t = vis[i + Number(b.dataset.tlvNav)];
      if (t) t.scrollIntoView({ behavior: 'smooth' });
    });
  });
  feed.addEventListener('scroll', function () { clearTimeout(feed._t); feed._t = setTimeout(pintarNav, 120); }, { passive: true });

  /* teclado (escritorio) */
  document.addEventListener('keydown', function (e) {
    if (!e.key) return;
    if (!sheet.hidden) {
      if (e.key === 'Escape') { e.preventDefault(); cerrarCom(); }
      else if (e.key === 'Tab') cicloTab(e);
      return;
    }
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    var t = e.target;
    if (t && t.closest && t.closest('input,textarea,select,[contenteditable]')) return;
    var enControl = t && t.closest && t.closest('button,a,[role=button]');
    var vis = visibles(), i = vis.indexOf(actual);
    if (e.key === 'ArrowDown' && vis[i + 1]) { e.preventDefault(); vis[i + 1].scrollIntoView({ behavior: 'smooth' }); }
    if (e.key === 'ArrowUp' && vis[i - 1]) { e.preventDefault(); vis[i - 1].scrollIntoView({ behavior: 'smooth' }); }
    if (e.key === ' ' && actual && !enControl) {
      e.preventDefault();
      var v = vid(actual);
      if (muted) { setMute(false); v.play().catch(function () {}); actual.classList.remove('is-paused'); }
      else if (v.paused) { v.play().catch(function () {}); actual.classList.remove('is-paused'); }
      else { v.pause(); actual.classList.add('is-paused'); }
    }
    if (e.key.toLowerCase() === 'm' && !enControl) mb.click();
  });

  /* volver de una ficha (bfcache) o cambiar de app */
  document.addEventListener('visibilitychange', function () {
    if (!actual) return; var v = vid(actual); if (!v) return;
    if (document.hidden) v.pause();
    else if (!actual.classList.contains('is-paused')) v.play().catch(function () { if (actual) actual.classList.add('is-paused'); });
  });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    contar(); likes = store(LS) || likes; pintarLikes();
    if (actual && !actual.classList.contains('is-paused')) { var v = vid(actual); if (v) v.play().catch(function () { if (actual) actual.classList.add('is-paused'); }); }
  });

  /* entrada por link (?v=clave, ?tab=ranking|guardados) y pista de deslizar */
  var qs = new URLSearchParams(location.search), q = qs.get('v'), qt = qs.get('tab');
  var ini = q && slides.filter(function (s) { return s.dataset.key === q; })[0];
  if (qt === 'ranking' || qt === 'guardados') tab(qt, ini);
  else if (ini) { ini.scrollIntoView(); activar(ini); } else activar(slides[0]);
  if (!store('tlv-visto') && hint) {
    hint.hidden = false; store('tlv-visto', 1);
    setTimeout(sinPista, 5200);
    feed.addEventListener('scroll', sinPista, { once: true, passive: true });
    root.addEventListener('pointerdown', sinPista, { once: true });
    document.addEventListener('keydown', sinPista, { once: true });
  }
})();
